// _-,:/.'()&+​01234789abcdefghijklmnopqrstuvwxyz
const ORGANIZATION_NAME_REGEX = new RegExp(/^[-,.'()&\w\s]*$/);
const UNDERSCORE = new RegExp(/_/);
/**
 * Validates that an organization name is valid.
 */
export const Validator = {
    name: "organization-name",
    errorMessage: "This field may only contain alpha-numeric characters, as well as dashes, dots and parentheses.",
    validate: (value) => ORGANIZATION_NAME_REGEX.test(value) && !UNDERSCORE.test(value),
};
